import { ValueCell } from './value-cell';

export class TableCell {
  columnId?: string;
  valueCells: ValueCell[];
  show: boolean;
  editable: boolean;
  cssClass: string = '';

  constructor() {
      this.columnId = null;
      this.valueCells = [];
      this.show = true;
      this.editable = false;
  }

  public findValueCellByDataId(dataId: string): ValueCell {
      return this.valueCells.find(c => c.dataId === dataId);
  }

  addVc(vc: ValueCell): void {
    this.valueCells.push(vc);
  }

  addCss(cssClass: string): void {
    if (!this.cssClass.includes(cssClass)) {
      const newCss = this.cssClass.concat(' ', cssClass);
      this.cssClass = newCss;
    }
  }

  /**
   * Get first ValueCell
   */
  getFirst(): ValueCell {
    return this.valueCells.length > 0 ? this.valueCells[0] : null;
  }
}
